import { render, staticRenderFns } from "./customerOutboundChannelSelect.vue?vue&type=template&id=0adf0384&"
import script from "./customerOutboundChannelSelect.vue?vue&type=script&lang=js&"
export * from "./customerOutboundChannelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports